import React, { Component, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const Menu = () => {
  const location = useLocation();
  useEffect(() => {
    console.log(location.pathname);
  }, [location.pathname]);
  return (
    <div>
      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        {/* Brand Logo */}
        <a href="index3.html" className="brand-link">
          
          <span className="brand-text font-weight-light">
            Climate Solutions
          </span>
        </a>
        {/* Sidebar */}
        <div className="sidebar">
          {/* Sidebar user panel (optional) */}
          {/* <div className="user-panel mt-3 pb-3 mb-3 d-flex">
            <div className="image">
              <img
                src="dist/img/user2-160x160.jpg"
                className="img-circle elevation-2"
                alt="User Image"
              />
            </div>
            <div className="info">
              <a href="#" className="d-block">
                Admin
              </a>
            </div>
          </div> */}
          {/* Sidebar Menu */}
          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              {/* Add icons to the links using the .nav-icon class
           with font-awesome or any other icon font library */}
              <li className="nav-item has-treeview menu-open">
                <Link to="/" className="nav-link active">
                  <i className="nav-icon fas fa-tachometer-alt" />
                  <p>
                    Dashboard
                    <i className="right fas fa-angle-left" />
                  </p>
                </Link>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <Link
                      to="/orders"
                      className={`nav-link ${
                        location.pathname.includes("orders") && "active"
                      }`}
                    >
                      <i className="far fa-circle nav-icon" />
                      <p>Orders</p>
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link
                      to="/products"
                      className={`nav-link ${
                        location.pathname.includes("products") && "active"
                      }`}
                    >
                      <i className="far fa-circle nav-icon" />
                      <p>Products</p>
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link
                      to="/coupons"
                      className={`nav-link ${
                        location.pathname.includes("coupons") && "active"
                      }`}
                    >
                      <i className="far fa-circle nav-icon" />
                      <p>Coupons</p>
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
          {/* /.sidebar-menu */}
        </div>
        {/* /.sidebar */}
      </aside>
    </div>
  );
};

export default Menu;
